import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.css";
import router from "./router/index";
import { store } from "./store/index";
import firebase from "firebase/app";
import "firebase/firestore";
import format from "date-fns/format";
import VueGoodWizard from "vue-good-wizard";
import CmpAlert from "./components/shared/Alert.vue";

Vue.use(VueGoodWizard);
Vue.use(Vuetify, {
  theme: {
    primary: "#1e90ff",
    secondary: "#424242",
    accent: "#1976D2",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#cc2625"
  }
});

firebase.initializeApp({
  apiKey: "AIzaSyBTqk5kidCskduALU-UzEcvY-81RQ4n6N0",
  authDomain: "creative-cards-app-171c7.firebaseapp.com",
  databaseURL: "https://creative-cards-app-171c7.firebaseio.com",
  projectId: "creative-cards-app-171c7",
  storageBucket: "creative-cards-app-171c7.appspot.com",
  messagingSenderId: "50267489214"
});

const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);

export const db = firestore;

Vue.component("app-alert", CmpAlert);

Vue.filter("formatDateFull", function(value) {
  if (value) {
    return format(value, "ddd. MMM Do, YYYY");
  }
});

Vue.filter("formatDateShort", function(value) {
  if (value) {
    return format(value, "MM-DD-YYYY");
  }
});

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return format(Date(value), "MM-DD-YYYY");
  }
});

Vue.directive("focus", {
  inserted: function(el) {
    el.__vue__.focus();
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const loggedInUser = store.state.user;
    if (!loggedInUser) {
      store.commit("clearUser");
      next({ name: "signin" });
    } else {
      next();
    }
  }
  next();
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  store,
  router,
  render: h => h(App),
  created() {
    if (this.$store.state.user === null) {
      this.$router.push("/signin");
    }
  }
});
